// Resolves API + Cognito endpoints at runtime (window.RUNTIME_CONFIG from
// /config.js), with build-time VITE_* fallbacks and localhost defaults, by
// kast-common's createDeploymentConfig. An empty value counts as unset.

import { cognitoFields, createDeploymentConfig } from "@jkast90/kast-common/config";

// This app calls the sign-in site's URL `loginUrl`.
const { cognitoUiUrl: loginUrl, ...cognito } = cognitoFields();

export const deploymentConfig = createDeploymentConfig({
  env: import.meta.env,
  // No per-device overrides.
  storage: null,
  fields: {
    // The dev server proxies /salvagers-api to the deployed API.
    apiUrl: { key: "VITE_SALVAGERS_API_BASE_URL", default: "/salvagers-api" },
    ...cognito,
    loginUrl,
  },
});

export type DeploymentConfig = ReturnType<typeof deploymentConfig.get>;

export const getDeploymentConfig = deploymentConfig.get;
